module.exports = __webpack_public_path__ + "static/media/test_tube.88b71693.png";